
import { LabelId__get_unwrap, FormState__startLoading, FormState_get_empty, RequestedValue$1 } from "../Shared/Shared.js";
import { isEmpty, map, singleton, empty } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Msg, State } from "./Types.js";
import { Cmd_OfPromise_either } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../CommunicationV2.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Label_$reflection } from "../Shared/Category.js";
import { list_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ValidationOnGetRequest } from "../ErrorHandling.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { toISOString } from "../Common.js";
import { CategoryUtilizationDto_$reflection } from "../Shared/Utilization.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { equals } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

export function init() {
    return [new State(new RequestedValue$1(0, []), empty(), undefined, undefined, undefined, undefined, FormState_get_empty()), Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(Label_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), "/api/categories", (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(7, [Item_1])))];
}

export function update(msg, state) {
    let categoryIds_3, startDate_3, endDate_3, startDate_1, endDate_1;
    switch (msg.tag) {
        case 1:
            return [new State(state.Categories, msg.fields[0], state.StartDate, state.EndDate, state.Utilization, state.LevelFilter, state.FormState), Cmd_none()];
        case 2:
            return [new State(state.Categories, state.SelectedCategoryIds, msg.fields[0], state.EndDate, state.Utilization, state.LevelFilter, state.FormState), Cmd_none()];
        case 3:
            return [new State(state.Categories, state.SelectedCategoryIds, state.StartDate, msg.fields[0], state.Utilization, state.LevelFilter, state.FormState), Cmd_none()];
        case 4: {
            const matchValue = state.SelectedCategoryIds;
            const matchValue_1 = state.StartDate;
            const matchValue_2 = state.EndDate;
            let matchResult, categoryIds_2, endDate_2, startDate_2;
            if (matchValue_1 != null) {
                if (matchValue_2 != null) {
                    if ((startDate_1 = matchValue_1, (endDate_1 = matchValue_2, !isEmpty(matchValue)))) {
                        matchResult = 0;
                        categoryIds_2 = matchValue;
                        endDate_2 = matchValue_2;
                        startDate_2 = matchValue_1;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return [new State(state.Categories, state.SelectedCategoryIds, state.StartDate, state.EndDate, state.Utilization, state.LevelFilter, FormState__startLoading(state.FormState)), (categoryIds_3 = map(LabelId__get_unwrap, categoryIds_2), (startDate_3 = toISOString(startDate_2), (endDate_3 = toISOString(endDate_2), Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_2;
                        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
                            const pr = response.arrayBuffer();
                            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), CategoryUtilizationDto_$reflection()));
                        }, refreshOn)))(true).then((_arg_1) => {
                            const result_1 = _arg_1;
                            return (result_1.tag === 1) ? (Promise.resolve((() => {
                                throw new ValidationOnGetRequest(result_1.fields[0]);
                            })())) : (Promise.resolve(result_1.fields[0]));
                        });
                    })), `/api/utilization/?categoryIds=${join(",", categoryIds_3)}&startDate=${startDate_3}&endDate=${endDate_3}`, (Item) => (new Msg(5, [Item])), (Item_1) => (new Msg(7, [Item_1]))))))];
                default:
                    return [state, Cmd_none()];
            }
        }
        case 5:
            return [new State(state.Categories, state.SelectedCategoryIds, state.StartDate, state.EndDate, msg.fields[0], undefined, FormState_get_empty()), Cmd_none()];
        case 6: {
            const level = msg.fields[0];
            return [new State(state.Categories, state.SelectedCategoryIds, state.StartDate, state.EndDate, state.Utilization, equals(state.LevelFilter, level) ? undefined : level, state.FormState), Cmd_none()];
        }
        case 7:
            return [new State(state.Categories, state.SelectedCategoryIds, state.StartDate, state.EndDate, state.Utilization, state.LevelFilter, FormState_get_empty()), Cmd_none()];
        default:
            return [new State(new RequestedValue$1(1, [msg.fields[0]]), state.SelectedCategoryIds, state.StartDate, state.EndDate, state.Utilization, state.LevelFilter, state.FormState), Cmd_none()];
    }
}

